var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_vm._v("\n  Загрузка...\n  "),_c('InternalLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }